<template>
	<TeamingChip2 class="browse-templates-chip">
		<template #left-icon>
			<FontAwesomeIcon :icon="[ `far`, `bars-staggered` ]" />
		</template>
		<template #default>
			{{ translate("text") }}
		</template>
	</TeamingChip2>
</template>

<script>
import {
	TeamingChip2
} from "@teaming/common-ui";

export default {
	name: "BrowseTemplatesChip",
	components: {
		TeamingChip2,
	},
	methods: {
		translate( key, args = {} ) {
			const { name, } = this.$options;
			return this.$t( `common-team.components.${ name }.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
